<template>
  <div id='pageContainer'>
    <div id='viewer' class='pdfViewer'></div>
  </div>
</template>

<script lang='ts'>
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component, Prop, Mixins } from 'vue-property-decorator'
import 'pdfjs-dist/web/pdf_viewer.css'
import MxSite from '@/mixins/site'

import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs'
import * as pdfjsViewer from 'pdfjs-dist/web/pdf_viewer.mjs'

pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/src/pdf.worker.mjs'
@Component({
})
export default class extends Mixins(MxSite) {
  @Prop()
  public docPath!: string

  public pdfPageCount = 0
  public currentPage = 1

  mounted() {
    this.getPdfFile()
  }

  async getPdf() {
    const container = document.getElementById('pageContainer')

    const eventBus = new pdfjsViewer.EventBus()
    const loadingTask = pdfjsLib.getDocument({ url: this.docPath })
    const pdfDocument = await loadingTask.promise
    const pdfPage = await pdfDocument.getPage(1)
    const pdfPageView = new pdfjsViewer.PDFPageView({
      container,
      eventBus,
      id: 1,
      scale: 1,
      defaultViewport: pdfPage.getViewport({ scale: 1 }),
    })
    pdfPageView.setPdfPage(pdfPage)
    pdfPageView.draw()
  }

  async getPdfFile() {
    const container = document.getElementById('pageContainer')
    const eventBus = new pdfjsViewer.EventBus()

    // (Optionally) enable hyperlinks within PDF files.
    const pdfLinkService = new pdfjsViewer.PDFLinkService({
      eventBus,
    })

    // (Optionally) enable find controller.
    const pdfFindController = new pdfjsViewer.PDFFindController({
      eventBus,
      linkService: pdfLinkService,
    })

    // (Optionally) enable scripting support.
    const pdfScriptingManager = new pdfjsViewer.PDFScriptingManager({
      eventBus,
    })

    const pdfViewer = new pdfjsViewer.PDFViewer({
      container,
      eventBus,
      linkService: pdfLinkService,
      findController: pdfFindController,
      scriptingManager: pdfScriptingManager,
    })
    pdfLinkService.setViewer(pdfViewer)
    pdfScriptingManager.setViewer(pdfViewer)

    eventBus.on('pagesinit', function() {
      // We can use pdfViewer now, e.g. let's change default scale.
      pdfViewer.currentScaleValue = 'page-width'

      // We can try searching for things.
      // if (SEARCH_FOR) {
      //  eventBus.dispatch('find', { type: '', query: SEARCH_FOR })
      // }
    })

    eventBus.on('lastpage', function() {
      console.log('lastpagereached')
    })

    eventBus.on('pagechanging', (page) => this.checkLastPage(page))

    // Loading document.
    const loadingTask = pdfjsLib.getDocument({
      url: this.docPath,
      enableXfa: true,
    })

    const pdfDocument = await loadingTask.promise
    this.pdfPageCount = pdfDocument.numPages
    // Document loaded, specifying document for the viewer and
    // the (optional) linkService.
    console.log(pdfDocument)
    pdfViewer.setDocument(pdfDocument)

    pdfLinkService.setDocument(pdfDocument, null)
  }

  public checkLastPage(page) {
    this.currentPage = page.pageNumber
    if (this.currentPage === this.pdfPageCount) {
      this.$emit('onLastPage', true)
    }
  }
}
</script>
<style>
#pageContainer {
  overflow: auto;
  position: absolute;
  width: 100%;
  height: 100%;
}

div.page {
  display: inline-block;
}
</style>
